export const AppName = {
  Affinity: 'Affinity',
  AirTable: 'AirTable',
  AllVue: 'AllVue',
  ArkPes: 'Ark PES',
  Carta: 'Carta',
  Cobalt: 'Cobalt',
  Dropbox: 'Dropbox',
  GoogleDrive: 'Google Drive',
  ILevel: 'iLevel',
  QuickBooks: 'QuickBooks',
  Salesforce: 'Salesforce',
  Slack: 'Slack',
  StandardMetrics: 'StandardMetrics',
  Xero: 'Xero',
} as const;
export type AppName = (typeof AppName)[keyof typeof AppName];

export interface IIntegrationsAppDataModel {
  appName: AppName;
  id?: number | null;
  isConnected: boolean;
  oauthUrl: string;
  connections?: string[] | null;
  supportMultipleConnections?: boolean | null;
  connectionType?: string;
  cartaV2?: boolean;
}

export function createIntegrationsAppDataModel(
  overrides: Partial<IIntegrationsAppDataModel> = {}
): IIntegrationsAppDataModel {
  return {
    id: -1,
    isConnected: false,
    oauthUrl: '',
    appName: AppName.AirTable,
    cartaV2: false,
    ...overrides,
  };
}
